import { useEffect, useReducer, useState } from 'react';
/**
 * Compares two sorted numeric arrays
 */
function arrayIsEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false;
    }
    if (Object.is(arr1, arr2)) {
        return true;
    }
    for (let index = 0; index < arr1.length; index++) {
        if (arr1[index] !== arr2[index]) {
            return false;
        }
    }
    return true;
}
function observerReducer(prev, next) {
    if (next === null) {
        return null;
    }
    if (prev &&
        Object.is(prev.root, next.root) &&
        prev.rootMargin === next.rootMargin &&
        arrayIsEqual(prev.thresholds, next.thresholds)) {
        return prev;
    }
    prev === null || prev === void 0 ? void 0 : prev.disconnect();
    return next;
}
export function useIntersectionObserver(options) {
    const { root, rootMargin, threshold } = options;
    const [entry, setEntry] = useState(null);
    const [observer, setObserver] = useReducer(observerReducer, null);
    useEffect(() => {
        setObserver(new IntersectionObserver((entries) => {
            const newEntry = entries.filter((entry) => entry.isIntersecting)[0];
            if (newEntry) {
                setEntry(newEntry);
            }
        }, {
            root,
            rootMargin,
            threshold,
        }));
    }, [root, rootMargin, threshold]);
    return { observer, entry };
}
//# sourceMappingURL=useIntersectionObserver.js.map